module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 22.422 26.468",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }